var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:['alert-details__warning', `alert-details__warning--${_vm.alertType}`]},[_c('i',{class:_vm.iconClass()}),_vm._v(_vm._s(_vm.message))])
}
var staticRenderFns = []

export { render, staticRenderFns }